import * as React from 'react';
import { connect } from 'react-redux';
import { GlobalPrivateState, getCountryNameByCode } from 'src/api';
import { Dispatch } from 'redux';

import { FormattedMessage } from 'react-intl';
import MESSAGES from 'src/app/Pages/Profile/Account-Profile/AccountProfile.messages';
import { Link } from 'react-router-dom';
import { ModalContainer } from 'src/app/Container/Modal/Modal';
import { AccountProfileForm } from './AccountProfileForm';

export interface AccountProfileProps {
  dispatch: Dispatch;
  location: GlobalPrivateState['router']['location'];
  modals: GlobalPrivateState['modals'];
  userData: GlobalPrivateState['userData'];
}

const modalId = 'profile-edit';

export class AccountProfilePartial extends React.Component<AccountProfileProps> {
  public render() {
    return this.userData ? (
      <>
        <div className="col-12 col-md-6 col-lg-6 user-data d-flex justify-content-center align-items-center flex-wrap pr-4">
          <div className="form-group-inner w-100 h-100">
            <div className="row">

              <div className="col-12 col-lg-6">
                <div className="row">
                  <div className="col-12">
                    <div className="field">
                      <h6>
                        <FormattedMessage {...MESSAGES.accountProfileName} />
                      </h6>
                      <p className="m-0">{this.userData.firstName}</p>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="field">
                      <h6>
                        <FormattedMessage {...MESSAGES.accountProfileTelephone} />
                      </h6>
                      <p className="m-0">{this.userData.phone}</p>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="field">
                      <h6>
                        <FormattedMessage {...MESSAGES.accountProfileStreet} />
                      </h6>
                      <p className="m-0">{this.userData.street}</p>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="field border-0">
                      <h6>
                        <FormattedMessage {...MESSAGES.accountProfileZip} />
                      </h6>
                      <p className="m-0">{this.userData.zip}</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-12 col-lg-6">
                <div className="row">
                  <div className="col-12">
                    <div className="field">
                      <h6>
                        <FormattedMessage {...MESSAGES.accountProfileSurname} />
                      </h6>
                      <p className="m-0">{this.userData.lastName}</p>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="field">
                      <h6>
                        <FormattedMessage {...MESSAGES.accountProfileMobile} />
                      </h6>
                      <p className="m-0">{this.userData.mobile}</p>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="field">
                      <h6>
                        <FormattedMessage {...MESSAGES.accountProfileCity} />
                      </h6>
                      <p className="m-0">{this.userData.city}</p>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="field border-0">
                      <h6>
                        <FormattedMessage {...MESSAGES.accountProfileCountry} />
                      </h6>
                      <p className="m-0">{getCountryNameByCode(this.userData.country)}</p>
                    </div>
                  </div>
                </div>
              </div>
              
            </div>
            <Link
              className="btn btn-secondary"
              to={`${this.props.location.pathname}?${modalId}=true`}
            >
              <FormattedMessage {...MESSAGES.accountProfileUserButton} />
            </Link>
          </div>
        </div>

        <ModalContainer
          byQuery={true}
          className="login-security-modal"
          id={modalId}
          showCloseBtn={true}
        >
          <div className="account-profile-modal d-flex justify-content-center align-items-center">
            <div className="container">
              <div className="inner w-100 p-5">                      
                <AccountProfileForm />
              </div>
            </div>
          </div>
        </ModalContainer>  
      </>
    ) : null;
  }

  private get userData(): GlobalPrivateState['userData']['result'] | undefined {
    return this.props.userData && this.props.userData.result;
  }
}

export const AccountProfile = connect((state: GlobalPrivateState) => ({
  location: state.router.location,
  modals: state.modals,
  userData: state.userData,
}))(AccountProfilePartial);
